import { Typography, Box } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function TerminosUso(){
  return (
    <>
      <SEO 
        title="Términos de Uso | Rolsys Solutions"
        description="Términos y condiciones de uso del sitio web de Rolsys Solutions."
      />

      <Box>
        <Typography variant="h3" sx={{ mb:3, fontWeight:800 }}>
          Términos de Uso
        </Typography>

        <Typography paragraph>
          El uso de este sitio web implica la aceptación plena de estos términos y condiciones. 
          Si no está de acuerdo con alguno de estos términos, le recomendamos no utilizar este sitio.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Uso del sitio
        </Typography>
        <Typography paragraph>
          Este sitio web es propiedad de Rolsys Solutions y está destinado a proporcionar información 
          sobre nuestros servicios de asesoría en TI y soporte técnico. El contenido es únicamente 
          informativo y puede ser actualizado sin previo aviso.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Servicios
        </Typography>
        <Typography paragraph>
          Los servicios están sujetos a disponibilidad y cobertura geográfica específica:
        </Typography>
        <Typography component="ul" sx={{ pl: 3 }}>
          <Typography component="li">Asesoría en TI: Cobertura nacional</Typography>
          <Typography component="li">Soporte remoto: Todo México</Typography>
          <Typography component="li">Soporte en sitio y mantenimiento: Solo Ciudad de México</Typography>
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Limitación de responsabilidad
        </Typography>
        <Typography paragraph>
          Rolsys Solutions no se hace responsable por daños directos o indirectos que puedan 
          derivarse del uso de este sitio web o de la información contenida en él.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          Última actualización: Enero 2024
        </Typography>
      </Box>
    </>
  );
}